module.exports = __webpack_public_path__ + "static/img/DIRECTOR_TheShapOfWater_BTS_Trailer_GDT_TEXTED-01.f8c8a56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DIRECTOR_TheShapOfWater_BTS_Trailer_GDT_TEXTED-01.jpg
// module id = 213
// module chunks = 0